import React from "react"
import { Typography, Button, Stack } from "@mui/material"
import PropTypes from "prop-types"
import i18n from "i18n"

const InvoicesHeader = ({ onAddNewInvoice, title = "Facturas" }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{ width: "100%", marginBottom: "20px" }}
  >
    <Typography variant="h6" component="h1">
      {title}
    </Typography>
    <Button
      variant="contained"
      color="branded"
      onClick={onAddNewInvoice}
      data-testid="invoices-new-invoice-button"
    >
      {i18n.t("invoices.newInvoice")}
    </Button>
  </Stack>
)

InvoicesHeader.propTypes = {
  onAddNewInvoice: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default InvoicesHeader
